export const getPolicyholder = (involved: any) =>
    involved?.find((participant: any) => participant?.typSnippet?.name === 'Versicherungsnehmer');
